import { Component, Host, Input, Optional } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { SwitchComponent } from '../switch/switch.component';
import { DatepickerComponent } from '../datepicker/datepicker.component';
import { DropdownComponent } from '../dropdown/dropdown.component';

@Component({
    selector: 'tvcore-input-error',
    templateUrl: './input-error.component.html',
    styleUrls: ['./input-error.component.scss'],
    standalone: false
})
export class InputErrorComponent {
	@Input()
	name: string;

	constructor(
		@Optional() @Host() private datepickerComponent: DatepickerComponent,
		@Optional() @Host() private dropdownComponent: DropdownComponent,
		@Optional() @Host() private inputComponent: InputComponent,
		@Optional() @Host() private switchComponent: SwitchComponent
	) {}

	hasError(name: string): boolean {
		return this.datepickerComponent?.hasError(name) || this.dropdownComponent?.hasError(name) || this.inputComponent?.hasError(name) || this.switchComponent?.hasError(name);
	}
}
